import offerCardSmall from './OfferCardSmall.html'
import offerCardFull from './OfferCard.html'
import { processTemplate } from './offerCardUtils'
import { generateColorPaletteWithoutBabel, getContrastColor } from './colorUtils'

// Função para extrair ordem das melhores ofertas do objeto builder_email_configuration
export function extractBestOfferOrder(builderEmailConfiguration) {
  if (!builderEmailConfiguration || !builderEmailConfiguration.body || !builderEmailConfiguration.body.rows) {
    return []
  }

  const bestOfferOrder = []

  // Percorrer rows em ordem
  builderEmailConfiguration.body.rows.forEach((row, rowIndex) => {
    if (row.columns) {
      // Percorrer columns em ordem
      row.columns.forEach((column, columnIndex) => {
        if (column.contents && column.contents.length > 0) {
          // Verificar se o primeiro content é um offer_card
          const firstContent = column.contents[0]
          if (firstContent && firstContent.type === 'custom' && firstContent.slug === 'offer_card' && firstContent.values && firstContent.values.bestOffer) {
            bestOfferOrder.push({
              rowIndex,
              columnIndex,
              bestOffer: firstContent.values.bestOffer,
              htmlID: firstContent.values._meta?.htmlID,
            })
          }
        }
      })
    }
  })

  return bestOfferOrder
}

// Função para detectar se é modo de edição (processed_html preenchido)
export function isEditMode(message) {
  return !!(message && message.processed_html && message.processed_html.trim().length > 0)
}

export function getOfferCardCustomJS(defaultColors, maxOfferCards = 10, message = null) {
  const processTemplateCode = processTemplate.toString()
  const generateColorPaletteCode = generateColorPaletteWithoutBabel.toString()
  const getContrastColorCode = getContrastColor.toString()
  const baseColor = defaultColors?.finish?.main || '#011F3E'
  const colorPalette = generateColorPaletteWithoutBabel(baseColor)

  // Extrair ordem das melhores ofertas se estiver em modo de edição
  const isEdit = isEditMode(message)
  const bestOfferOrder = isEdit ? extractBestOfferOrder(message?.builder_email_configuration) : []

  return `
    (function() {
      const htmlTemplateSmall = \`${offerCardSmall}\`;
      const htmlTemplateLarge = \`${offerCardFull}\`;
      
      const processTemplate = ${processTemplateCode};
      const generateColorPaletteWithoutBabel  = ${generateColorPaletteCode};
      const getContrastColor = ${getContrastColorCode};
      
      unlayer.registerTool({
        name: 'offer_card',
        label: 'Oferta',
        icon: 'fa-tag',
        supportedDisplayModes: ['web', 'email'],
        options: {
          size: {
            title: 'Tamanho',
            position: 0,
            collapsed: false,
            options: {
              templateSize: {
                label: 'Tamanho do Cartão',
                defaultValue: 'small',
                widget: 'dropdown'
              }
            }
          },
          bestOffer: {
            title: 'Melhor Oferta',
            position: 1,
            collapsed: false,
            options: {
              bestOffer: {
                label: 'Melhor Oferta',
                defaultValue: '1',
                widget: 'dropdown',
              },
            },
          },
          font: {
            title: 'Fontes',
            position: 1,
            collapsed: false,
            options: {
              fontFamily: {
                label: 'Fonte',
                defaultValue: {
                  "label": "Lato",
                  "value": "'Lato',sans-serif"
                },
                widget: 'font_family',
              }
            }
          },
          colors: {
            title: 'Cores',
            position: 1,
            collapsed: false,
            options: {
              mecanicaOfferColor: {
                label: 'Cor principal (Mecânica)',
                defaultValue: '${baseColor}',
                widget: 'color_picker',
              },
              descontoColor: {
                label: 'Cor secundária (Desconto)',
                defaultValue: '${colorPalette.light}',
                widget: 'color_picker',
              },
            },
          },
        },
        transformer: (values, source) => {

          if (source.name === 'mecanicaOfferColor') {
            const colorPalette = generateColorPaletteWithoutBabel(source.value);

            const next = {
              ...values,
              mecanicaOfferColor: source.value,
              descontoColor: colorPalette.light,
            };

            try {
              if (typeof window !== 'undefined') {
                window.dispatchEvent(new CustomEvent('offerCardColorChange', {
                  detail: { mecanicaColor: source.value, descontoColor: colorPalette.light },
                }));
              }
            } catch {}

            return next;
          }

          if (source.name === 'descontoColor') {
            const next = { ...values, descontoColor: source.value };

            try {
              if (typeof window !== 'undefined') {
                window.dispatchEvent(new CustomEvent('offerCardColorChange', {
                  detail: { mecanicaColor: null, descontoColor: source.value },
                }));
              }
            } catch {}

            return next;
          }

          if (source.name === 'fontFamily') {
            const font = (source.value && typeof source.value === 'object')
              ? source.value
              : { label: 'Lato', value: "'Lato',sans-serif" };

            const next = { ...values, fontFamily: font };

            try {
              if (typeof window !== 'undefined') {
                window.dispatchEvent(new CustomEvent('offerCardFontChange', {
                  detail: { fontFamily: font },
                }));
              }
            } catch {}

            return next;
          }

          if (source.name === 'bestOffer') {
            const offerNumber = source.value;
            const offerName = offerNumber + 'ª Melhor Oferta';
            return { ...values, 'nome da oferta': offerName };
          }

          return values;
        },
        values: {
          'nome da oferta': '1ª Melhor Oferta',
          'unidade': 'Unidade',
          'fim da validade': 'Válido até [data validade]',
          'desconto da oferta': 'Desconto',
          'imagem da oferta': 'Imagem do produto ofertado',
          'regra min max': 'Regra min/máx',
          'mecanica oferta': 'Mecânica oferta',
          templateSize: 'small',
          fontFamily: {
            "label": "Lato",
            "value": "'Lato',sans-serif"
          },
          bestOffer: '1',
          mecanicaOfferColor: '${baseColor}',
          descontoColor: '${colorPalette.light}'
        },
        renderer: {
          Viewer: unlayer.createViewer({
            render: function(values, data) {
              const selectedSize = values.templateSize || 'small';
              const selectedTemplate = selectedSize === 'large' ? htmlTemplateLarge : htmlTemplateSmall;
              const result = processTemplate(selectedTemplate, values);
              return result;
            },
          }),
          exporters: {
            web: function (values, data) {
              const selectedSize = values.templateSize || 'small';
              const selectedTemplate = selectedSize === 'large' ? htmlTemplateLarge : htmlTemplateSmall;
              return processTemplate(selectedTemplate, values);
            },
            email: function (values, data) {
              const selectedSize = values.templateSize || 'small';
              const selectedTemplate = selectedSize === 'large' ? htmlTemplateLarge : htmlTemplateSmall;
              return processTemplate(selectedTemplate, values);
            }
          },
          head: {
            css: function (values, data) {
              if (!values || !values._meta) {
                return '';
              }
              
              const htmlID = values._meta.htmlID;
              const fontFamily = values.fontFamily && values.fontFamily.value ? values.fontFamily.value : (values.fontFamily || 'Lato');
              
              const mecanicaColor = values.mecanicaOfferColor || '${baseColor}';
              
              let cssString = \`
                #\${values._meta.htmlID} .offer-card-small-container table,td { 
                  color: \${getContrastColor(values.descontoColor)};
                } 

                #\${values._meta.htmlID} .offer-card-small-container {
                  font-family: \${fontFamily} !important;
                }
                
                #\${values._meta.htmlID} .offer-card-small-badge {
                  background: \${mecanicaColor} !important;
                  color: \${getContrastColor(mecanicaColor)} !important;
                }
                
                #\${values._meta.htmlID} .discount-offer-container-small {
                  background: \${values.descontoColor} !important;
                  color: \${getContrastColor(values.descontoColor)} !important;
                }

                @media (prefers-color-scheme: dark) {
                  #\${values._meta.htmlID} .offer-card-small-container table{
                    background-color: #FFFFFF !important;
                  }

                  #\${values._meta.htmlID} .offer-card-small-container table,td { 
                    color: \${getContrastColor(values.descontoColor)};
                  } 

                  #\${values._meta.htmlID} .offer-card-small-badge {
                    background: \${mecanicaColor} !important;
                    color: \${getContrastColor(mecanicaColor)} !important;
                  }
                  
                  #\${values._meta.htmlID} .discount-offer-container-small {
                    background: \${values.descontoColor} !important;
                    color: \${getContrastColor(values.descontoColor)} !important;
                  }
                  
                  #\${values._meta.htmlID}[data-ogsc] .offer-card-small-container,
                  #\${values._meta.htmlID}[data-ogsc] .offer-card-small-container * {
                    background-color: #FFFFFF !important;
                    color: inherit !important;
                  }
                  #\${values._meta.htmlID}[data-darkreader-mode] .offer-card-small-container,
                  #\${values._meta.htmlID}[data-darkreader-mode] .offer-card-small-container * {
                    background-color: #FFFFFF !important;
                    color: inherit !important;
                  }
                }

                #\${values._meta.htmlID} .offer-card-container {
                  font-family: \${fontFamily} !important;
                }
                
                #\${values._meta.htmlID} .offer-card-badge {
                  background-color: \${mecanicaColor} !important;
                  color: \${getContrastColor(mecanicaColor)} !important;
                  font-family: \${fontFamily} !important;
                }
                
                #\${values._meta.htmlID} .offer-card-image-text {
                  font-family: \${fontFamily} !important;
                }
                
                #\${values._meta.htmlID} .offer-card-rule {
                  font-family: \${fontFamily} !important;
                }
                
                #\${values._meta.htmlID} .offer-card-footer {
                  padding-left: 12px;
                  vertical-align: bottom;
                }
                
                #\${values._meta.htmlID} .offer-card-product-name {
                  font-family: \${fontFamily} !important;
                }
                
                #\${values._meta.htmlID} .offer-card-unit {
                  font-family: \${fontFamily} !important;
                }
                
                #\${values._meta.htmlID} .offer-card-footer-item {
                  font-family: \${fontFamily} !important;
                }
                
                #\${values._meta.htmlID} .discount-offer-container {
                  background-color: \${values.descontoColor} !important;
                  font-family: \${fontFamily} !important;
                  color: \${getContrastColor(values.descontoColor)} !important;
                }

                @media (prefers-color-scheme: dark) {
                  #\${values._meta.htmlID} .offer-card-container table{
                    background-color: #FFFFFF !important;
                  }

                 #\${values._meta.htmlID} .offer-card-badge {
                    background-color: \${mecanicaColor} !important;
                    color: \${getContrastColor(mecanicaColor)} !important;
                    font-family: \${fontFamily} !important;
                  }
                  
                  #\${values._meta.htmlID} .offer-card-image-text {
                    font-family: \${fontFamily} !important;
                  }
                  
                  #\${values._meta.htmlID} .offer-card-rule {
                    font-family: \${fontFamily} !important;
                  }
                  
                  #\${values._meta.htmlID} .offer-card-footer {
                    padding-left: 12px;
                    vertical-align: bottom;
                  }
                  
                  #\${values._meta.htmlID} .offer-card-product-name {
                    font-family: \${fontFamily} !important;
                  }
                  
                  #\${values._meta.htmlID} .offer-card-unit {
                    font-family: \${fontFamily} !important;
                  }
                  
                  #\${values._meta.htmlID} .offer-card-footer-item {
                    font-family: \${fontFamily} !important;
                  }
                  
                  #\${values._meta.htmlID} .discount-offer-container {
                    background-color: \${values.descontoColor} !important;
                    font-family: \${fontFamily} !important;
                    color: \${getContrastColor(values.descontoColor)} !important;
                  }

                  #\${values._meta.htmlID}[data-ogsc] .offer-card-container,
                  #\${values._meta.htmlID}[data-ogsc] .offer-card-container * {
                    background-color: #FFFFFF !important;
                    color: inherit !important;
                  }
                  #\${values._meta.htmlID}[data-darkreader-mode] .offer-card-container,
                  #\${values._meta.htmlID}[data-darkreader-mode] .offer-card-container * {
                    background-color: #FFFFFF !important;
                    color: inherit !important;
                  }
                }

                @media only screen and (max-width:480px) {
                  #\${values._meta.htmlID} .product-name-cell { height: 19px !important; }
                  #\${values._meta.htmlID} .offer-card-small-badge { font-size: 16px !important; }
                  #\${values._meta.htmlID} .offer-card-small-rule { font-size: 14px !important; }
                  #\${values._meta.htmlID} .product-name { font-size: 18px !important; }
                  #\${values._meta.htmlID} .product-footer-item { font-size: 14px !important; }
                }
                
              \`;
              return cssString;
            },
            js: function(values) {
              const htmlID = values._meta.htmlID;
              const toolbarBestOffer = values.bestOffer || '1';
              
              return \`
                (function() {
                  const htmlID = '\${htmlID}';
                  const toolbarBestOffer = '\${toolbarBestOffer}';

                  // ===== Tooltip para "Melhor Oferta" =====
                  (function setupBestOfferTooltipOnce() {
                    // evita rodar de novo quando novos cards carregam
                    if (window.__offerHelpTipInitialized) return;
                    window.__offerHelpTipInitialized = true;

                    var HELP_TEXT = 'Apenas produtos com imagem e preço/desconto cadastrados são considerados como oferta para esse componente do e-mail.';
                    var ALT_LABELS = ['Melhor Oferta', 'Best Offer'];
                    var TIP_ID = 'offer-best-offer-help';

                    function __txt(n) {
                      return (n && (n.textContent || n.innerText) || '').replace(/\\s+/g, ' ').trim();
                    }

                    function createTip() {
                      var tip = document.createElement('span');
                      tip.id = TIP_ID;
                      tip.textContent = 'i';
                      tip.title = HELP_TEXT;
                      tip.setAttribute('aria-label', HELP_TEXT);
                      tip.style.cursor = 'pointer';
                      tip.style.borderRadius = '50%';
                      tip.style.width = '16px';
                      tip.style.height = '16px';
                      tip.style.display = 'inline-flex';
                      tip.style.alignItems = 'center';
                      tip.style.justifyContent = 'center';
                      tip.style.fontSize = '12px';
                      tip.style.lineHeight = '16px';
                      tip.style.border = '1px solid #ccc';
                      tip.style.userSelect = 'none';
                      tip.style.fontFamily = 'sans-serif';
                      tip.style.background = '#fff';
                      tip.style.zIndex = 9999;
                      return tip;
                    }

                    function findAnchor() {
                    var LABEL_SEL = '.blockbuilder-widget-label.mb-2 ' +
                                    '> label.blockbuilder-label-primary ' +
                                    '> .sc-eEVuZf.has-value';

                    function norm(t){ return (t||'').replace(/\\s+/g,' ').trim(); }
                    

                    var nodes = document.querySelectorAll(LABEL_SEL);
                    for (var i = 0; i < nodes.length; i++) {
                      var txt = norm(nodes[i].textContent || nodes[i].innerText);
                      if (txt === 'Melhor Oferta' || txt.indexOf('Melhor Oferta') !== -1) {
                        return nodes[i];
                      }
                    }

                    var generic = document.querySelector('.property-panel .label, .unlayer-property-panel .label');
                    return generic || null;
                  }

                    function ensureTipOnce() {
                      var tip = document.getElementById(TIP_ID) || createTip();
                      var anchor = findAnchor();
                      if (anchor && tip.parentElement !== anchor) {
                        try { anchor.appendChild(tip); } catch (e) {
                          try { anchor.insertAdjacentElement('beforeend', tip); } catch(_) {}
                        }
                      }
                    }

                    ensureTipOnce();

                    try {
                      var mo = new MutationObserver(function() {
                        ensureTipOnce();
                      });
                      mo.observe(document.body, { childList: true, subtree: true });
                      window.addEventListener('beforeunload', function(){ try{ mo.disconnect(); }catch(_){ } });
                    } catch(_) {
                      setInterval(ensureTipOnce, 2000);
                    }
                  })();

                  
                  // Sistema global de controle de execução
                  if (!window.offerCardsProcessed) {
                    window.offerCardsProcessed = new Set();
                  }
                  
                  // Verificar se este card já foi processado
                  if (window.offerCardsProcessed.has(htmlID)) {
                    return; // Já foi processado, não executar novamente
                  }
                  
                  // Marcar como processado imediatamente
                  window.offerCardsProcessed.add(htmlID);
                  
                  const currentCard = document.getElementById(htmlID);
                  
                  // SISTEMA DE AUTO-NUMERAÇÃO DE MELHOR OFERTA
                  
                  // Função para contar cards existentes e determinar próximo número
                  const getNextOfferNumber = () => {
                    // Se estiver em modo de edição e tiver ordem definida, usar a ordem salva
                    const isEdit = ${isEdit};
                    const bestOfferOrder = ${JSON.stringify(bestOfferOrder)};
                    
                    if (isEdit && bestOfferOrder && bestOfferOrder.length > 0) {
                      // Encontrar o card atual na ordem salva
                      const currentCardOrder = bestOfferOrder.find(order => order.htmlID === htmlID);
                      if (currentCardOrder) {
                        return parseInt(currentCardOrder.bestOffer);
                      }
                    }
                    
                    const unlayerBody = document.body;
                    const allCards = unlayerBody.querySelectorAll('[aria-offer]');
                    
                    // EXCLUIR o card atual da contagem
                    const currentCardElement = document.getElementById(htmlID);
                    
                    // Verificar se o card atual já tem um número válido
                    const currentAriaOffer = currentCardElement.getAttribute('aria-offer');
                    if (currentAriaOffer && currentAriaOffer.includes('best-offer-')) {
                      const currentNumber = parseInt(currentAriaOffer.replace('best-offer-', ''));
                      if (!isNaN(currentNumber)) {
                        // Card já tem número válido, não alterar
                        return currentNumber;
                      }
                    }
                    
                    const existingCards = Array.from(allCards).filter(card => {
                      const ariaOffer = card.getAttribute('aria-offer');
                      // Verificar se o card é o elemento atual OU se é filho do elemento atual
                      const isCurrentCard = card === currentCardElement || currentCardElement.contains(card);
                      // Excluir o card atual (elemento ou filho)
                      return ariaOffer && ariaOffer.includes('best-offer-') && !isCurrentCard;
                    });
                    
                    // Extrair números dos cards existentes (excluindo o atual)
                    const existingNumbers = [];
                    existingCards.forEach(card => {
                      const ariaOffer = card.getAttribute('aria-offer');
                      if (ariaOffer && ariaOffer.includes('best-offer-')) {
                        const number = parseInt(ariaOffer.replace('best-offer-', ''));
                        if (!isNaN(number)) {
                          existingNumbers.push(number);
                        }
                      }
                    });
                    
                    // Usar limite máximo baseado na mesma lógica do bestOfferOptions
                    const maxOffers = ${maxOfferCards};
                    
                    // Encontrar próximo número disponível
                    let nextNumber = 1;
                    while (existingNumbers.includes(nextNumber) && nextNumber <= maxOffers) {
                      nextNumber++;
                    }
                    
                    // Se atingiu o limite máximo, reutilizar a última oferta disponível
                    if (nextNumber > maxOffers) {
                      nextNumber = maxOffers;
                    }
                    
                    return nextNumber;
                  };
                  
                  // FUNCIONALIDADE OTIMIZADA: Card selecionado e dropdown aberto automaticamente (RÁPIDO)
                  const selectCardAndOpenDropdown = () => {
                    // Processo mais rápido - reduzir timeouts
                    setTimeout(() => {
                      // 1. Selecionar o card no editor
                      const cardElement = document.getElementById(htmlID);
                      if (cardElement) {
                        // Simular clique no card para selecioná-lo
                        cardElement.click();
                        
                        // Processo mais rápido - reduzir timeout
                        setTimeout(() => {
                          // 2. Selecionar a opção correspondente ao número do card (dinâmico)
                          const offerNumber = getNextOfferNumber();
                          const targetOfferText = offerNumber + 'ª Melhor Oferta';
                          
                          const targetOfferOption = Array.from(document.querySelectorAll('.dropdown-item')).find(item => {
                            const label = item.querySelector('.label');
                            return label && label.textContent.trim() === targetOfferText;
                          });
                          
                          if (targetOfferOption) {
                            // Executar o clique na opção
                            targetOfferOption.click();
                          } else {
                          }
                        }, 300); // Reduzido de 800ms para 300ms
                      }
                    }, 500); // Reduzido de 1200ms para 500ms
                  };
                  
                  // FUNCIONALIDADE IMEDIATA: Tentar executar sem timeouts primeiro
                  const tryImmediateExecution = () => {
                    const cardElement = document.getElementById(htmlID);
                    if (cardElement) {
                      // Tentar selecionar imediatamente
                      cardElement.click();
                      
                      // Tentar selecionar opção imediatamente
                      const offerNumber = getNextOfferNumber();
                      const targetOfferText = offerNumber + 'ª Melhor Oferta';
                      
                      const targetOfferOption = Array.from(document.querySelectorAll('.dropdown-item')).find(item => {
                        const label = item.querySelector('.label');
                        return label && label.textContent.trim() === targetOfferText;
                      });
                      
                      if (targetOfferOption) {
                        targetOfferOption.click();
                        return true; // Sucesso imediato
                      }
                    }
                    return false; // Falhou, usar timeouts
                  };
                  
                  // Tentar execução imediata primeiro
                  if (!tryImmediateExecution()) {
                    // Se falhou, usar a abordagem com timeouts
                    selectCardAndOpenDropdown();
                  }
                  
                  // FUNCIONALIDADE ALTERNATIVA OTIMIZADA: Usar API do Unlayer se disponível (RÁPIDO)
                  const tryUnlayerAPI = () => {
                    setTimeout(() => {
                      // Tentar usar a API do Unlayer se estiver disponível
                      if (window.unlayer && window.unlayer.getEditor) {
                        try {
                          const editor = window.unlayer.getEditor();
                          if (editor) {
                            // Tentar selecionar o elemento e abrir o painel de propriedades
                            const element = editor.getSelectedElement();
                            if (element && element.id === htmlID) {
                              
                              // Processo mais rápido
                              setTimeout(() => {
                                const offerNumber = getNextOfferNumber();
                                const targetOfferText = offerNumber + 'ª Melhor Oferta';
                                
                                const targetOfferOption = Array.from(document.querySelectorAll('.dropdown-item')).find(item => {
                                  const label = item.querySelector('.label');
                                  return label && label.textContent.trim() === targetOfferText;
                                });
                                
                                if (targetOfferOption) {
                                  targetOfferOption.click();
                                }
                              }, 200); // Reduzido de 500ms para 200ms
                            }
                          }
                        } catch (error) {
                        }
                      }
                    }, 800); // Reduzido de 2000ms para 800ms
                  };
                  
                  // Executar tentativa alternativa
                  tryUnlayerAPI();
                  
                  // FUNCIONALIDADE ADICIONAL: Monitorar eventos do Unlayer
                  const setupUnlayerEventListeners = () => {
                    // Tentar configurar listeners para eventos do Unlayer
                    if (window.unlayer) {
                      try {
                        // Listener para quando um elemento é selecionado
                        window.unlayer.addEventListener('design:updated', () => {
                          setTimeout(() => {
                            const selectedElement = document.querySelector('.unlayer-element-selected, .selected');
                            if (selectedElement && selectedElement.id === htmlID) {
                              // Tentar selecionar opção após seleção
                              setTimeout(() => {
                                const offerNumber = getNextOfferNumber();
                                const targetOfferText = offerNumber + 'ª Melhor Oferta';
                                
                                const targetOfferOption = Array.from(document.querySelectorAll('.dropdown-item')).find(item => {
                                  const label = item.querySelector('.label');
                                  return label && label.textContent.trim() === targetOfferText;
                                });
                                if (targetOfferOption) {
                                  targetOfferOption.click();
                                }
                              }, 500);
                            }
                          }, 100);
                        });
                      } catch (error) {
                      }
                    }
                  };
                  
                  // Configurar listeners
                  setupUnlayerEventListeners();
                  
                  // FUNCIONALIDADE FINAL OTIMIZADA: MutationObserver para detectar mudanças no DOM (RÁPIDO)
                  const setupMutationObserver = () => {
                    // Observar mudanças no DOM para detectar quando o painel de propriedades é carregado
                    const observer = new MutationObserver((mutations) => {
                      mutations.forEach((mutation) => {
                        if (mutation.type === 'childList') {
                          // Verificar se o painel de propriedades foi adicionado
                          const addedNodes = Array.from(mutation.addedNodes);
                          const hasPropertyPanel = addedNodes.some(node => {
                            if (node.nodeType === Node.ELEMENT_NODE) {
                              return node.classList?.contains('property-panel') || 
                                     node.classList?.contains('unlayer-property-panel') ||
                                     node.querySelector?.('.property-panel, .unlayer-property-panel');
                            }
                            return false;
                          });
                          
                          if (hasPropertyPanel) {
                            // Processo mais rápido - sem timeout adicional
                            const offerNumber = getNextOfferNumber();
                            const targetOfferText = offerNumber + 'ª Melhor Oferta';
                            
                            const targetOfferOption = Array.from(document.querySelectorAll('.dropdown-item')).find(item => {
                              const label = item.querySelector('.label');
                              return label && label.textContent.trim() === targetOfferText;
                            });
                            
                            if (targetOfferOption) {
                              targetOfferOption.click();
                              // Parar de observar após sucesso
                              observer.disconnect();
                            }
                          }
                        }
                      });
                    });
                    
                    // Começar a observar mudanças no body
                    observer.observe(document.body, {
                      childList: true,
                      subtree: true
                    });
                    
                    // Parar de observar após 5 segundos para evitar vazamentos de memória (reduzido de 10s)
                    setTimeout(() => {
                      observer.disconnect();
                    }, 5000);
                  };
                  
                  // Configurar MutationObserver
                  setupMutationObserver();
                  
                  // ===== MUTATION OBSERVER PARA ELEMENTOS BLOCKBUILDER =====
                  const setupBlockBuilderObserver = () => {
                    // Cria o observer para elementos blockbuilder
                    const blockBuilderObserver = new MutationObserver((mutations) => {
                      mutations.forEach((mutation) => {
                        // Verifica apenas mudanças de atributos (classes)
                        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                          const target = mutation.target;
                          
                          // Verifica se o elemento tem as classes blockbuilder E se tem a classe blockbuilder-layer-selected
                          if (target.classList && 
                              target.classList.contains('blockbuilder-layer') && 
                              target.classList.contains('blockbuilder-layer-selectable') &&
                              target.classList.contains('blockbuilder-layer-selected')) {
                            
                            // Identifica qual melhor oferta é a oferta do card
                            let melhorOferta = 'Não identificado';
                            
                            // Busca o texto da oferta dentro do elemento
                            const nomeOfertaElement = target.querySelector('.product-name, .offer-card-product-name');
                            if (nomeOfertaElement && nomeOfertaElement.textContent) {
                              melhorOferta = nomeOfertaElement.textContent.trim();
                            }
                            
                            // Elemento selecionado com informação da oferta
                            
                            // Altera o valor do dropdown de melhor oferta diretamente sem abrir as opções
                            const melhorOfertaPanel = document.querySelector('.melhor_oferta_panel');
                            if (melhorOfertaPanel) {
                              const dropdownButton = melhorOfertaPanel.querySelector('button[role="combobox"].dropdown-button');
                              if (dropdownButton) {
                                // Altera diretamente o texto do label do botão dropdown
                                const labelSpan = dropdownButton.querySelector('.label');
                                if (labelSpan) {
                                  labelSpan.textContent = melhorOferta;
                                }
                                
                                // Dispara evento de mudança para notificar o sistema
                                dropdownButton.dispatchEvent(new Event('change', { bubbles: true }));
                              }
                            }
                          }
                        }
                      });
                    });

                    // Configurações do observer
                    const observerConfig = {
                      subtree: true,       // Observa toda a árvore DOM
                      attributes: true,    // Observa mudanças de atributos
                      attributeFilter: ['class'], // Apenas mudanças na classe
                    };

                    // Inicia a observação no body do documento atual (contexto do Unlayer)
                    blockBuilderObserver.observe(document.body, observerConfig);
                  };

                  // Configurar o BlockBuilder Observer
                  setupBlockBuilderObserver();
                  
                  const setupAriaLabelSync = () => {
                    const syncAriaLabelWithSpan = (button) => {
                      const ariaLabel = button.getAttribute('aria-label');
                      const spanLabel = button.querySelector('.label');
                      
                      if (ariaLabel && spanLabel && ariaLabel !== spanLabel.textContent) {
                        spanLabel.textContent = ariaLabel;
                      }
                    };
                    
                    const syncAllDropdownButtons = () => {
                      const dropdownButtons = document.querySelectorAll('button[role="combobox"].dropdown-button');
                      dropdownButtons.forEach(button => {
                        syncAriaLabelWithSpan(button);
                      });
                    };
                    
                    syncAllDropdownButtons();
                    
                    const ariaLabelObserver = new MutationObserver((mutations) => {
                      mutations.forEach((mutation) => {
                        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-label') {
                          const button = mutation.target;
                          if (button && button.classList.contains('dropdown-button')) {
                            syncAriaLabelWithSpan(button);
                          }
                        }
                      });
                    });
                    
                    const newButtonsObserver = new MutationObserver((mutations) => {
                      mutations.forEach((mutation) => {
                        if (mutation.type === 'childList') {
                          mutation.addedNodes.forEach((node) => {
                            if (node.nodeType === Node.ELEMENT_NODE) {
                              if (node.classList && node.classList.contains('dropdown-button')) {
                                syncAriaLabelWithSpan(node);
                                ariaLabelObserver.observe(node, {
                                  attributes: true,
                                  attributeFilter: ['aria-label']
                                });
                              }
                              
                              const dropdownButtons = node.querySelectorAll && node.querySelectorAll('button[role="combobox"].dropdown-button');
                              if (dropdownButtons) {
                                dropdownButtons.forEach(button => {
                                  syncAriaLabelWithSpan(button);
                                  ariaLabelObserver.observe(button, {
                                    attributes: true,
                                    attributeFilter: ['aria-label']
                                  });
                                });
                              }
                            }
                          });
                        }
                      });
                    });
                    
                    newButtonsObserver.observe(document.body, {
                      childList: true,
                      subtree: true
                    });
                    
                    const existingButtons = document.querySelectorAll('button[role="combobox"].dropdown-button');
                    existingButtons.forEach(button => {
                      ariaLabelObserver.observe(button, {
                        attributes: true,
                        attributeFilter: ['aria-label']
                      });
                    });
                    
                    setInterval(syncAllDropdownButtons, 1000);
                  };
                  
                  setupAriaLabelSync();
                  
                  // Para novos cards, sempre usar auto-numeração
                  const offerNumber = getNextOfferNumber();
                  
                  // Atualizar o card atual com o número correto
                  if (currentCard) {
                    // Atualizar aria-offer
                    currentCard.setAttribute('aria-offer', 'best-offer-' + offerNumber);
                    
                    // Atualizar texto "nome da oferta" se existir
                    const nomeOfertaElement = currentCard.querySelector('.product-name, .offer-card-product-name');
                    if (nomeOfertaElement) {
                      nomeOfertaElement.textContent = offerNumber + 'ª Melhor Oferta';
                    }
                    
                    // Card atualizado com número correto
                  }
                  
                  // Função para reordenar todos os cards (útil quando um card é removido)
                  const reorderAllOfferCards = () => {
                    const unlayerBody = document.body;
                    const allCards = unlayerBody.querySelectorAll('[aria-offer]');
                    
                    // Reordenando todos os cards de oferta
                    
                    // Ordenar cards por posição no DOM
                    const sortedCards = Array.from(allCards).sort((a, b) => {
                      const aRect = a.getBoundingClientRect();
                      const bRect = b.getBoundingClientRect();
                      return aRect.top - bRect.top || aRect.left - bRect.left;
                    });
                    
                    // Renumerar sequencialmente
                    sortedCards.forEach((card, index) => {
                      const newNumber = index + 1;
                      card.setAttribute('aria-offer', 'best-offer-' + newNumber);
                      
                      // Atualizar texto
                      const nomeOfertaElement = card.querySelector('.product-name, .offer-card-product-name');
                      if (nomeOfertaElement) {
                        nomeOfertaElement.textContent = newNumber + 'ª Melhor Oferta';
                      }
                    });
                    
                    // Cards reordenados
                  };
                  
                  // Expor função globalmente para uso manual
                  window.reorderAllOfferCards = reorderAllOfferCards;
                  
                  // FUNÇÃO UTILITÁRIA: Configurar card manualmente
                  window.configureOfferCard = (cardId, offerNumber = null) => {
                    const cardElement = document.getElementById(cardId);
                    if (!cardElement) {
                      return;
                    }
                    
                    // Se não especificado, usar o número automático baseado no card
                    if (!offerNumber) {
                      // Tentar extrair o número do aria-offer do card
                      const ariaOffer = cardElement.getAttribute('aria-offer');
                      if (ariaOffer && ariaOffer.includes('best-offer-')) {
                        offerNumber = ariaOffer.replace('best-offer-', '');
                      } else {
                        // Fallback: usar a função getNextOfferNumber
                        offerNumber = getNextOfferNumber();
                      }
                    }
                    
                    const targetOfferText = offerNumber + 'ª Melhor Oferta';
                    
                    // Selecionar o card
                    cardElement.click();
                    
                    setTimeout(() => {
                      // Selecionar opção específica
                      const targetOption = Array.from(document.querySelectorAll('.dropdown-item')).find(item => {
                        const label = item.querySelector('.label');
                        return label && label.textContent.trim() === targetOfferText;
                      });
                      
                      if (targetOption) {
                        targetOption.click();
                      } else {
                      }
                    }, 200); // Reduzido de 500ms para 200ms
                  };
                  
                  // Função para limpar controle global quando card é removido
                  window.clearOfferCardProcessed = (cardId) => {
                    if (window.offerCardsProcessed) {
                      window.offerCardsProcessed.delete(cardId);
                    }
                  };
                  
                  // Função para definir limite máximo de ofertas
                  window.setMaxOfferCards = (maxCards) => {
                    window.maxOfferCards = maxCards;
                  };
                  
                  
                  function checkAriaOffer() {
                    const container = document.getElementById(htmlID);
                    if (container) {
                      const badges = container.querySelectorAll('.offer-card-small-container, .offer-card-container');
                      badges.forEach((badge, index) => {
                        const ariaOffer = badge.getAttribute('aria-offer');
                        if (!ariaOffer || ariaOffer.includes('{{')) {
                          badge.setAttribute('aria-offer', 'best-offer-1');
                        }
                      });
                    }
                  }
                  
                  setTimeout(() => {
                    const container = document.getElementById(htmlID);
                    if (container) {
                      const badges = container.querySelectorAll('.offer-card-small-container, .offer-card-container');
                      const needsUpdate = Array.from(badges).some(badge => {
                        const ariaOffer = badge.getAttribute('aria-offer');
                        return !ariaOffer || ariaOffer.includes('{{');
                      });
                      
                      if (needsUpdate) {
                        checkAriaOffer();
                      }
                    }
                  }, 100);
                })();
              \`;
            }
          }
        }
      });
      
      function hideDuplicateButtons() {
        const allDuplicateButtons = document.querySelectorAll('.blockbuilder-duplicate');
        
        allDuplicateButtons.forEach(button => {
          const blockbuilderLayer = button.closest('.blockbuilder-layer');
          if (blockbuilderLayer && blockbuilderLayer.querySelector('.u_content_custom_offer_card')) {
            button.style.display = 'none';
            button.style.visibility = 'hidden';
            button.style.opacity = '0';
            button.style.pointerEvents = 'none';
          }
        });
      }
      
      hideDuplicateButtons();
      setTimeout(hideDuplicateButtons, 100);
      setTimeout(hideDuplicateButtons, 500);
      setTimeout(hideDuplicateButtons, 1000);
      
      const observer = new MutationObserver(function(mutations) {
        let hasChanges = false;
        
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(function(node) {
              if (node.nodeType === 1) {
                if (node.classList && node.classList.contains('blockbuilder-duplicate')) {
                  hasChanges = true;
                } else if (node.classList && node.classList.contains('u_content_custom_offer_card')) {
                  hasChanges = true;
                } else if (node.classList && node.classList.contains('blockbuilder-layer')) {
                  hasChanges = true;
                } else if (node.querySelector && node.querySelector('.u_content_custom_offer_card')) {
                  hasChanges = true;
                } else if (node.querySelector && node.querySelector('.blockbuilder-duplicate')) {
                  hasChanges = true;
                }
              }
            });
          }
        });
        
        if (hasChanges) {
          hideDuplicateButtons();
          setTimeout(hideDuplicateButtons, 50);
          setTimeout(hideDuplicateButtons, 200);
        }
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
      
      setInterval(hideDuplicateButtons, 2000);
    })();
  `
}
